module.exports = __webpack_public_path__ + "img/water-inner-corner.40662192.png";